import { Phone, Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import logo2 from "@/assets/logo2.png";

export function Footer() {
  const { t } = useTranslation(["common", "nav"]);
  return (
    <footer className="bg-surface text-surface-foreground">
      <div className="mx-auto max-w-7xl px-6 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <img
              src={logo2}
              alt="Salmamy Drill"
              className="h-20 w-auto object-contain drop-shadow-md"
            />
          </div>
          <p className="mt-6 max-w-sm text-surface-foreground/60 leading-relaxed">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-surface-foreground/40 font-semibold">
            {t("footer.navigation")}
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a href="/forage-surface" className="hover:text-primary transition">
                {t("nav:surface")}
              </a>
            </li>
            <li>
              <a href="/forage-souterrain" className="hover:text-primary transition">
                {t("nav:underground")}
              </a>
            </li>
            <li>
              <a href="/forage-eau" className="hover:text-primary transition">
                {t("nav:water")}
              </a>
            </li>
            <li>
              <a href="/equipements" className="hover:text-primary transition">
                {t("nav:equipment")}
              </a>
            </li>
            <li>
              <a href="/management" className="hover:text-primary transition">
                {t("nav:management")}
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:text-primary transition">
                {t("nav:contact")}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-surface-foreground/40 font-semibold">
            {t("footer.contact")}
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <MapPin className="w-4 h-4 text-primary shrink-0" />
              Sotuba ACI, route de la corniche, à côté du 3ème pont, porte 07, Bamako, Mali
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-primary shrink-0" /> contact@salmamydrill.com
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-primary shrink-0" /> 20 21 75 02
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-surface-foreground/10">
        <div className="mx-auto max-w-7xl px-6 py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-surface-foreground/40">
          <span>{t("footer.rights", { year: new Date().getFullYear() })}</span>
        </div>
      </div>
    </footer>
  );
}
